import axios from "axios";
import router from '@/router/index.js';
import tokenCtrl from '@/lib/token';

const baseURL = process.env.VUE_APP_API_URL;
const instance = axios.create({
    baseURL: baseURL,
    headers: { "content-type": "application/json" },
    timeout: 30000,
    withCredentials: true,
    crossDomain: true,
    credentials: "include"
});

instance.interceptors.request.use(
    async config => {

        // Access token expire check
        return await tokenCtrl.accessTokenChk(config);
        // return config;
    },
    error => {
        console.log('@@@@@ request error @@@@@');
        return Promise.reject(error);
    }
);

instance.interceptors.response.use(
    (res) => {
        return res
    },
    (error) => {
        if (error.response.status === 401) {
            alert('로그인이 필요한 서비스입니다.');
            localStorage.clear()
            return router.push({name: 'login'});
            // return router.push({name: 'login', query: {redirectUrl: router.currentRoute.value.path}});
        } else if (error.response.status === 400) {
            if (error.response.data.message) {
                // alert(error.response.data.message);
            }
            return error.response;
        }
        return Promise.reject(error)
    }
)



export default instance;
